<template>
  <div />
</template>

<script>
export default {
  beforeMount() {
    this.$store.dispatch(
      'auth/confirmRegistration',
      {
        userId: this.$route.params.userId,
        confirmationCode: this.$route.params.confirmationCode,
      },
    )
      .then(() => {
        window.toast.notify.success(this.$t('auth.register.confirmed'))
      })
      .finally(() => this.$router.push({ name: 'login' }))
  },
}
</script>
